module.exports = __webpack_public_path__ + "static/media/calendar-mob.a6e9b2f6.svg";